<template>
    <button
        :class="[colorType === 'main' ? classStyles['text-main_color-600'] : classStyles['text-secondary_color-600'], styles.btn_simple]"
        :disabled="load"
        class="flex h-full items-center justify-center"
    >
        <slot/>
        <my-loader v-if="load"></my-loader>
    </button>
</template>

<script>
import MyLoader from '../../MyLoader'

export default {
  name: 'BaseButtonSimple',
  components: { MyLoader },
  props: {
    colorType: {
      type: String,
      default: 'main',
      validator (value) {
        return ['main', 'secondary'].includes(value)
      }
    },

    load: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      styles: window.myStyles,
      classStyles: window.class_styles
    }
  }
}
</script>

<style scoped>

</style>
